<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Select')"
    width="825px"
    append-to-body
    :close-on-click-modal="false"
    class="app-main-inner search"
  >
    <div class="app-main-inner-row" style="padding-bottom: 20px;">
      <el-form label-width="70px" label-position="left" style="width: 100%">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('CargoMsg.Cargo_Query')">
              <el-input v-model="filter.searchValue" class="custom-select-width" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="grid">
      <cargo-ag-grid
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :row-data="rowData"
        :show-side-bar="false"
        style="height:100%;min-height: 400px;"
      />
    </div>
    <div class="app-main-inner-row row-pagination-right">
      <cargo-pagination
        v-show="filter.total>0"
        config-module="150003"
        :total="filter.total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <div slot="footer" style="float: right">
      <el-button type="primary" no="3" @click="confirmSelect">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="4" @click="innerVisible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { getLoading } from '@/utils/utilBaseElement'
import { getThirdUserListFunc } from '@/api/user'

export default {
  name: 'ChooseThirdUserDialog',
  components: { cargoAdvanceSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowClicked: event => { this.selectedRow = event.data },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectedRow: null,
      filter: {
        searchValue: '',
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_email'),
          field: 'email',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'empName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UserCode'),
          field: 'empSysId',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MobilePhoneNo'),
          field: 'empMobileNumber',
          width: 200
        }
      ]
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.toQuery()
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.filter.searchValue = ''
        this.filter.pageNum = 1
        this.filter.pageSize = 10
        this.rowData = []
        this.selectedRow = null
      }
    }
  },
  created() {
    this.toQuery()
  },
  methods: {
    toQuery() {
      this.selectedRow = null
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.likeName = ''
      this.loading = getLoading()
      getThirdUserListFunc({ likeName: this.filter.searchValue, pageNum: this.filter.pageNum, pageSize: this.filter.pageSize }).then(res => {
        this.rowData = []
        if (res.data && res.data.list) {
          this.rowData = res.data.list
        }
        this.filter.total = res.data.total ? Number(res.data.total) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    async confirmSelect() {
      if (!this.selectedRow) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.$emit('callBack', this.selectedRow)
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
